import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=99a3ebde&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=99a3ebde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a3ebde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99a3ebde')) {
      api.createRecord('99a3ebde', component.options)
    } else {
      api.reload('99a3ebde', component.options)
    }
    module.hot.accept("./comment.vue?vue&type=template&id=99a3ebde&scoped=true", function () {
      api.rerender('99a3ebde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/program/programTask/components/comment.vue"
export default component.exports